import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  irps: { content: [] },
  modalidades: [],
  irp: {},
  itens: [],
  arquivos: []
});

function irpReducer(state = initialState, action) {
  switch (action.type) {
    case types.IRPS_START:
    case types.IRP_MODALIDADES_START:
    case types.IRP_START:
    case types.IRP_ITENS_START:
    case types.IRP_ARQUIVOS_START:
      return startLoad(state);

    case types.IRPS_SUCCESS:
      return endLoad(state.set('irps', fromJS(action.payload)));
    case types.IRP_MODALIDADES_SUCCESS:
      return endLoad(state.set('modalidades', fromJS(action.payload)));
    case types.IRP_SUCCESS:
      return endLoad(state.set('irp', fromJS(action.payload)));
    case types.IRP_ITENS_SUCCESS:
      return endLoad(state.set('itens', fromJS(action.payload)));
    case types.IRP_ARQUIVOS_SUCCESS:
      return endLoad(state.set('arquivos', fromJS(action.payload)));

    case types.IRPS_ERROR:
    case types.IRP_MODALIDADES_ERROR:
    case types.IRP_ERROR:
    case types.IRP_ITENS_ERROR:
    case types.IRP_ARQUIVOS_ERROR:
      return endLoad(state);

    case types.RESET_CONSULTA_IRPS:
      return initialState.set('modalidades', state.get('modalidades'));
    default:
      return state;
  }
}

export default irpReducer;
